"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MessageBarTitle: function() {
        return _index.MessageBarTitle;
    },
    messageBarTitleClassNames: function() {
        return _index.messageBarTitleClassNames;
    },
    renderMessageBarTitle_unstable: function() {
        return _index.renderMessageBarTitle_unstable;
    },
    useMessageBarTitleStyles_unstable: function() {
        return _index.useMessageBarTitleStyles_unstable;
    },
    useMessageBarTitle_unstable: function() {
        return _index.useMessageBarTitle_unstable;
    }
});
const _index = require("./components/MessageBarTitle/index");
